import React, { useEffect, useState } from 'react'
import { Checkbox, Stack, Typography } from '@mui/material'
import { com } from '@eidu/form'
import FieldValueEqualsInput from './FieldValueEqualsInput'
import { findEntityTypeByFieldId } from '../../util/EntityTypeExtensions'
import EntityTypeField from '../../pages/permission/path/EntityTypeField'
import EntityType = com.eidu.sharedlib.entity.type.EntityType
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId
import EntitySelector = com.eidu.sharedlib.entity.selector.EntitySelector

type EntitySelectorInputProps = {
  entityTypes: readonly EntityType[]
  entitySelector: EntitySelector
  setEntitySelector: (selector: EntitySelector) => void
  disabled?: boolean
}

const TargetSelectorInput: React.FC<EntitySelectorInputProps> = ({
  entityTypes,
  entitySelector,
  setEntitySelector,
  disabled = false,
}) => {
  const isDisabled = disabled
  const [filter, setFilter] = useState(entitySelector instanceof EntitySelector.FieldValueEquals)
  const [entityTypeId, setEntityTypeId] = useState<EntityTypeId | undefined>()

  useEffect(() => {
    if (entitySelector instanceof EntitySelector.OfType) {
      setFilter(false)
      setEntityTypeId(entitySelector.typeId)
    } else if (entitySelector instanceof EntitySelector.FieldValueEquals) {
      setFilter(true)
      const newEntityTypeId = findEntityTypeByFieldId(entityTypes, entitySelector.fieldId)
      if (newEntityTypeId) setEntityTypeId(newEntityTypeId.id)
    } else {
      throw new Error(`Unsupported entity selector type for TargetSelector: ${entitySelector}`)
    }
  }, [entitySelector])

  return (
    <Stack spacing={1} sx={{ padding: 2 }}>
      {entityTypes && (
        <EntityTypeField
          label="Type"
          types={entityTypes}
          entityTypeId={entityTypeId}
          onChange={(newEntityType) => {
            setEntitySelector?.(new EntitySelector.OfType(newEntityType.id))
          }}
          disabled={disabled}
        />
      )}
      {entityTypeId && (
        <Stack direction="row" spacing={1} sx={{ borderRadius: 1 }}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography>Filter</Typography>
            <Checkbox
              checked={filter}
              onChange={(_, isChecked) => {
                if (!isChecked) {
                  setEntitySelector?.(new EntitySelector.OfType(entityTypeId))
                }
                setFilter(isChecked)
              }}
            />
          </Stack>
          {filter && (
            <FieldValueEqualsInput
              disabled={isDisabled}
              entityTypeId={entityTypeId}
              selector={entitySelector as EntitySelector.FieldValueEquals}
              setSelector={(newSelector) => {
                if (newSelector) setEntitySelector?.(newSelector)
              }}
            />
          )}
        </Stack>
      )}
    </Stack>
  )
}

export default TargetSelectorInput
